<template>
  <div :class="$style.innerContent" v-bind="$attrs">
    <slot />
  </div>
</template>

<style module>
.innerContent {
  overflow: auto;
  margin-right: -20px;
  padding: 20px 20px 40px 0;
  max-height: calc(100vh - 190px);
}
</style>
